










import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'breadcrumb'
})
export default class Breadcrumb extends Vue {
  public breadcrumbList: Array<string> = [];

  @Watch('$route') onRouteChange (newval: any, oldval: any): void {
    (this.$refs.breadcrumbBox as HTMLElement).classList.remove('breadcrumbMoveclassName')
    setTimeout(() => {
      const resStr = newval.meta.title
      if (resStr) {
        this.breadcrumbList = resStr.split('-')
      } else {
        this.breadcrumbList = []
      }
      (this.$refs.breadcrumbBox as HTMLElement).classList.add('breadcrumbMoveclassName')
    }, 0)
  }

  // 当页面刷新的时候同样也是需要保持面包屑之前的状态：
  refreshPage (): void {
    const resStr = this.$route.meta.title
    if (resStr) {
      this.breadcrumbList = resStr.split('-')
    } else {
      this.breadcrumbList = []
    }
  }

  created (): void {
    this.refreshPage()
  }
}
